import React from 'react';

const HomeNotLogged = () => (
  <div style={{ textAlign: 'center', padding: 40 }}>
    <h1>YoPlay Studio</h1>
  </div>
);

export default HomeNotLogged;
